import { useContext, useEffect, useState } from "react"
import { UseCasesContext } from "../../../../context/useCases"
import { useTypedSelector } from "../../../../hooks/useTypedSelector"
import { Link, useParams } from "react-router-dom"
import { Menu } from "../../../components/menu"
import { ChevronRight } from "tabler-icons-react"

export const UploadLandingList = () => {
    let { id } = useParams();

    const [form, setForm] = useState<{ from: Date, to: Date }>({
        from: new Date(),
        to: new Date(),
    })

    useEffect(() => {
        let start = new Date();
        let end = new Date();
        start.setDate(start.getDate() - 30);
        end.setDate(end.getDate() + 1);
        setForm({
            ...form,
            from: start,
            to: end,
        })
    }, [])
    let useCases = useContext(UseCasesContext)

    const landings = useTypedSelector(({ landing }) => {
        return landing
    })


    useEffect(() => {
        useCases?.landingUseCase.ReadLandings()
    }, [])

    return (
        <div className="layout-page" >
            <Menu />
            <div className="content-wrapper" >
                <div className="container-xxl flex-grow-1 container-p-y">
                    <div className="row mx-1">
                        <div className="col-sm-12 col-md-4">
                            <h4 className="fw-bold py-3 mb-4"><span className="text-muted fw-light">Загрузка фото /</span> Лендинги</h4>
                        </div>

                        {
                            landings?.landings && landings.landings.map((landing, index) => {
                                return <Link  to={"/upload-task/paths/"+landing.Id()} className="card" style={{ margin: "10px", cursor: "pointer", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }} >
                                    <h4 style={{ padding: "10px", margin: "0" }}>{landing.Domain()}</h4>
                                    <ChevronRight />
                                </Link>
                            })
                        }

                    </div>
                </div>
            </div>
        </div>
    )

}